<template>
  <div ref="container">
    <a-modal :title="title" :width="1300" :visible="visible" :maskStyle="{'top':'93px','left':'154px'}" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:20%;height:80%;">
      <a-button @click="addstandard" type="primary" icon="plus">添加包装规格</a-button>
      <a-table :loading="loading" :dataSource="dataSource" :pagination="false" :columns="columns" @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a v-if="record.specificationName!='初级包装:0'" @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a v-if="record.specificationName!='初级包装:0'" @click="handleDelete(record)">删除</a>
          <!-- <template v-if="record.specificationName!='初级包装:0'">
            <a v-if="record.specificationName!='初级包装:0'" @click="handleEdit(record)">编辑</a>
            <a-divider type="vertical" />
            <a v-if="record.specificationName!='初级包装:0'" @click="handleDelete(record)">删除</a>
          </template>
          <template v-else>
            --
          </template> -->
        </span>
        
        <!-- 状态渲染模板 -->
        <template slot="packageLevel" slot-scope="packageSpecification">
          <span v-if="packageSpecification == 0">件</span>
          <span v-else-if="packageSpecification == 1">盒</span>
          <span v-else-if="packageSpecification == 2">箱</span>
        </template>
        <template slot="productDiMin" slot-scope="text">
          <span v-if="text">{{ text }}</span>
          <span v-else>--</span>
        </template>
      </a-table>
    </a-modal>
    <standardModel ref="standardModel" @close="getlist"></standardModel>
  </div>
</template>
<script>
import standardModel from './standardModel.vue'
import { getProductSpecification, deletePackage } from '@/api/api'
export default {
  name: 'VendorModal1',
  components: {
    standardModel,
  },
  data() {
    return {
      title: '包装规格',
      visible: false,
      model: {},
      dataSource: [],
      loading: false,
      id: '',
      getDIProps: {},
      specificationId: '',
      columns: [
        { title: '包装产品标识', dataIndex: 'productDi', width: 150, align: 'left' },
        {
          title: '包装规格',
          dataIndex: 'specificationName',
          width: 70,
          align: 'left',
        },
        {
          title: '产品包装单位',
          dataIndex: 'packageUnit',
          width: 100,
          align: 'left',
          scopedSlots: { customRender: 'packageUnit' },
        },
        // {
        { title: '本级包装内包含小一级相同产品标识的包装数量', dataIndex: 'packageNumber', width: 200, align: 'left' },
        // {
        { title: '包装内含一级包装产品标识值', dataIndex: 'productDiMin', width: 150, align: 'left',scopedSlots: { customRender: 'productDiMin' }, },
        {
          title: '操作',
          dataIndex: 'action',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  created() {},
  methods: {
    handleEdit(record) {
      this.$refs.standardModel.edit(record)
      this.$refs.standardModel.title = '编辑包装规格'
    },
    // 删除包装
    handleDelete(record){
      this.$confirm('是否删除包装', '确认操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        this.deletePackage(record)
      }).catch(() => {});
    },
    async deletePackage(record){
      const res = await deletePackage({id: record.id})
      if ( res.code == 200 && res.success == true ) {
        this.$message.success('删除成功')
        this.getlist()
      } else {
        this.$message.error(res.message)
      }
    },
    addstandard() {
      let params = {
        productDi: this.productDi,
        id: this.id,
        codeSystem:this.codeSystem,
        totalCodeSystem:this.totalCodeSystem,
      }
      console.log(params+' created')
      this.$refs.standardModel.add(params)
      this.$refs.standardModel.title = '新增包装规格'
    },
    async add(e) {
      console.log(e, 'e1')
      this.getDIProps = e
      this.visible = true
      if (e.id) {
        this.id = e.id
        this.productDi = e.productDi,
        this.codeSystem=e.codeSystem,
        this.totalCodeSystem=e.totalCodeSystem
        this.getlist()
      }
    },
    async getlist() {
      this.loading = true
      let params = {
        id: this.id,
        codeSystem:this.codeSystem,
        totalCodeSystem:this.totalCodeSystem,
      }
      console.log(params, 'params')
      const res = await getProductSpecification(params)
      console.log(res, 'res')
      if (res.errno == 200 && res.errmsg == '成功') {
        // res.data.forEach((it) => {
        //   it.materialName = e.name
        // })
        this.dataSource = res.data
        // this.ipagination.total = res.data.total
        this.loading = false
      } else {
        this.$message.error(res.data || res.errmsg)
        this.loading = false
      }
    },
    handleTableChange(pagination, filters, sorter) {
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc'
      }
      if (pagination && pagination.current) {
        this.ipagination = pagination
      }
      this.getlist()
    },
    async myHandleDetailPI(record) {
      this.$refs.PIreorcdref.add(record)
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      // 触发表单验证
      this.handleCancel()
    },
    handleCancel() {
      this.close()
    },
  },
}
</script>
<style scoped>
</style>